import { MissionBadge } from '@/features/missions/components/MissionBadge'
import type { ProficiencyAssessmentFinalResult } from '@/features/nectar/api/models'
import { Button, Text } from '@/ui-kit'
import { CheckCheck } from 'lucide-react'

type PhaseResultsProps = {
  finalResult: ProficiencyAssessmentFinalResult
  onBack: () => void
}

const CONFIDENCE_TEXT: Record<string, string> = {
  low: 'Low confidence',
  medium: 'Medium confidence',
  high: 'High confidence'
}

export const PhaseResults = ({ finalResult, onBack }: PhaseResultsProps) => {
  return (
    <div
      className="mx-auto flex w-full max-w-[600px] flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center"
      style={{ animation: 'nectar-slide-up 0.4s ease-out' }}
    >
      <div className="flex size-16 items-center justify-center rounded-full bg-green/10">
        <CheckCheck className="text-green size-8" />
      </div>

      <Text type="h5">Assessment Complete!</Text>

      <div className="flex flex-col items-center gap-2">
        <span className="text-h3 block">{finalResult.level}</span>
        <Text type="body2-regular" className="text-gray-80">
          Your estimated CEFR level
        </Text>
        <MissionBadge variant="success">{CONFIDENCE_TEXT[finalResult.confidence] ?? finalResult.confidence}</MissionBadge>
      </div>

      <Button size="small" onClick={onBack} className="mt-2">
        Back to Missions
      </Button>
    </div>
  )
}
